import ToggleContentToModal from './modules/toggle-content-to-modal';

const onFilterChange = () => {
  const queryMap = {};
  const filters = document.querySelectorAll('.filter-checkbox');
  filters.forEach((f) => {
    if (!f.checked) {
      return;
    }

    const queryParam = f.getAttribute('data-query-param');
    const queryValue = f.getAttribute('data-query-value');
    if (!queryMap[queryParam]) {
      queryMap[queryParam] = [];
    }

    queryMap[queryParam].push(queryValue);
  });

  const keys = [];
  const params = new URLSearchParams(window.location.search);
  params.forEach((v, k) => { keys.push(k); });
  const filterParams = keys.filter(k => k.includes('filter'));
  filterParams.forEach((f) => { params.delete(f); });

  Object.keys(queryMap).forEach((q) => { params.set(q, queryMap[q].join(',')); });

  const url = `${window.location.protocol}//${window.location.hostname}${window.location.pathname}`;
  if (params.toString().length === 0) {
    window.location.assign(url);
  } else {
    window.location.assign(`${url}?${params.toString()}`);
  }
};

const setupFilterChangeHandler = () => {
  const filters = document.querySelectorAll('.filter-checkbox');
  if (!filters) {
    return;
  }

  filters.forEach((f) => { f.onchange = onFilterChange; });
};

const removeFilterChangeHandler = () => {
  const filters = document.querySelectorAll('.filter-checkbox');
  if (!filters) {
    return;
  }

  filters.forEach((f) => { f.onchange = null; });
};

const queryParamsToMap = () => {
  const queryMap = {};
  const params = new URLSearchParams(window.location.search);
  params.forEach((v, k) => {
    if (k.includes('filter')) {
      queryMap[k] = v.split(',');
    }
  });

  return queryMap;
};

const setupCheckedFilters = () => {
  const filters = document.querySelectorAll('.filter-checkbox');
  if (!filters) {
    return;
  }

  const queryMap = queryParamsToMap();
  Object.keys(queryMap).forEach((k) => {
    filters.forEach((f) => {
      const filterParam = f.getAttribute('data-query-param');
      const filterValue = f.getAttribute('data-query-value');
      if (filterParam === k) {
        f.checked = queryMap[k].includes(filterValue);
      }
    });
  });
};

const setupClearFiltersHandler = () => {
  const btn = document.getElementById('clear-filters');
  btn.onclick = () => {
    const keys = [];
    const params = new URLSearchParams(window.location.search);
    params.forEach((v, k) => { keys.push(k); });
    keys.filter(k => k.includes('filter')).forEach((k) => { params.delete(k); });

    const url = `${window.location.protocol}//${window.location.hostname}${window.location.pathname}`;
    if (params.toString().length === 0) {
      window.location.assign(url);
    } else {
      window.location.assign(`${url}?${params.toString()}`);
    }
  };
};

const handleRefineOnClick = () => {
  onFilterChange();
};

const handleModalOpen = () => {
  const refineBtn = document.getElementById('modal-refine-btn');
  if (!refineBtn) {
    return;
  }

  refineBtn.onclick = handleRefineOnClick;
  removeFilterChangeHandler();
};

const handleModalClose = () => {
  setupFilterChangeHandler();
};

const handleProductGridLock = () => {
  const grid = document.getElementById('grid-lock');
  const nav = document.querySelector('.header-main-section');
  if (!grid || !nav) {
    return;
  }

  const params = new URLSearchParams(window.location.search);
  if (params.toString().length > 0) {
    window.setTimeout(() => {
      window.scrollTo({
        top: grid.offsetTop - nav.offsetHeight,
        behavior: 'smooth',
      });
    }, 100);

    const h2 = document.getElementById('results-focus');
    if (h2) {
      h2.focus();
    }
  }
};

setupCheckedFilters();
setupFilterChangeHandler();
setupClearFiltersHandler();
handleProductGridLock();

new ToggleContentToModal({ /* eslint-disable-line no-new */
  modalId: 'filter-and-sort-modal',
  toggleSelector: '.btn-filter-sort',
  toggleContent: [
    {
      content: '.product-filter-group',
      modalSelector: '#filter-and-sort-modal .product-filter-wrapper',
      defaultSelector: '.filtered-content-grid .product-filter-wrapper',
    },
  ],
  callbacks: {
    onOpen: handleModalOpen,
    onClose: handleModalClose,
  },
});
